import React, { useEffect, useState } from "react";
import { ChevronDown, Music2 } from "lucide-react";
import { usePlayer } from "../context/PlayerContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const toTitleCase = (s) =>
  (s || "").replace(/[A-Za-zÀ-ÿ]+(?:'[A-Za-zÀ-ÿ]+)*/g, (w) =>
    w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
  );

const ArtistInfo = () => {
  const { nowPlaying } = usePlayer();
  const title = nowPlaying?.title || "";
  const artist = title.includes(" - ") ? title.split(" - ")[0].trim() : "";
  const [info, setInfo] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!artist) {
      setInfo(null);
      return;
    }
    let active = true;
    (async () => {
      try {
        const res = await fetch(`${API}/artist-info?artist=${encodeURIComponent(artist)}`);
        if (!res.ok) return;
        const d = await res.json();
        if (active) setInfo(d);
      } catch (e) {
        /* ignore */
      }
    })();
    return () => { active = false; };
  }, [artist]);

  if (!artist || !info || (!info.fact && (!info.hits || info.hits.length === 0))) return null;

  return (
    <div
      data-testid="artist-info"
      className="rounded-2xl bg-[#4288F5] border border-white/15 px-4 py-3 shadow-lg shadow-blue-900/20"
    >
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        data-testid="artist-info-toggle"
        className="flex w-full items-center justify-between text-left"
      >
        <div>
          <span className="text-[10px] font-bold uppercase tracking-widest text-white/70">Nu op All-In Radio</span>
          <p className="font-heading text-base font-extrabold text-white">{info.artist}</p>
        </div>
        <span className="flex items-center gap-2 text-white/85">
          <span className="text-xs font-semibold">{open ? "Verberg" : "Toon"}</span>
          <ChevronDown className={`h-5 w-5 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
        </span>
      </button>

      <div className={`grid transition-all duration-300 ease-out ${open ? "grid-rows-[1fr] opacity-100 mt-3" : "grid-rows-[0fr] opacity-0"}`}>
        <div className="overflow-hidden">
          {info.fact ? (
            <p className="line-clamp-none text-sm leading-relaxed text-white/85">{info.fact}</p>
          ) : null}
          {info.hits && info.hits.length > 0 ? (
            <div className="mt-3">
              <p className="text-[10px] font-bold uppercase tracking-widest text-white/60">Bekende hits</p>
              <ul className="mt-1.5 space-y-1">
                {info.hits.slice(0, 2).map((h, i) => (
                  <li key={i} className="flex items-center gap-2 text-sm font-semibold text-white">
                    <Music2 className="h-3.5 w-3.5 shrink-0 text-white/70" /> {toTitleCase(h)}
                  </li>
                ))}
              </ul>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ArtistInfo;
